import FeedLayout from "layouts/files/FeedLayout";
import { Link } from "react-router-dom";
import { RuleItem, SVG } from "ui";

import { IncidentRulesOpen } from "components/files/modals/RulesModel";
import { useEffect, useState } from "react";
import { helpQuestion } from "assets/data/helpQuestions";

const Help = () => {
    const [rules, setRules] = useState<IncidentRulesOpen[]>([]);

    const setNRules = () => {
        const nRules: IncidentRulesOpen[] = helpQuestion.map((i) => ({
            ...i,
            isOpened: false
        }));
        setRules(nRules);
    };

    useEffect(() => {
        setNRules();
    }, []);

    const openRule = (attr: IncidentRulesOpen) => {
        const nRules = rules.map((r) => {
            if (r.question == attr.question) {
                return { ...r, isOpened: true };
            } else {
                return { ...r, isOpened: false };
            }
        });
        setRules(nRules);
    };
    return (
        <FeedLayout pageTitle="help" hideSideCards>
            <div className="moment-mark-page pb-40">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Help</h1>

                    <div></div>
                </div>

                <div className="card pr-20 pl-20 pt-20 pb-20">
                    <div className="rules-container">
                        {rules.map((r) => (
                            <RuleItem
                                item={r}
                                openRule={openRule}
                                close={setNRules}
                                key={r.question}
                            />
                        ))}
                    </div>
                </div>
                <div className="d-flex flex-j-start w-full pl-20 mt-20 mb-10">
                    <Link to="/privacy">Privacy Policy</Link>
                </div>
                <div className="d-flex flex-j-start w-full  pl-20 mb-30">
                    <Link to="/terms">Terms and Conditions</Link>
                </div>
            </div>
        </FeedLayout>
    );
};

export default Help;
